import request from '@/utils/request';

export function getChainStatistic(){
    return request({
        url: '/chain/statistic',
        method: 'post'
    })
}

export function getDetail(data){
    return request({
        url: '/transaction/detail',
        method: 'post',
        data
    })
}